import { Employee_NewDashboard_BasicDetailDto } from './employee-new-dashboard-basic-detail-dto.model';
import { ApiErrorCode } from '../service-proxies';


export class Employee_NewDashboard_BasicDetailDtoApiResponse implements IEmployee_NewDashboard_BasicDetailDtoApiResponse {
    isSuccess!: boolean;
    responseData!: Employee_NewDashboard_BasicDetailDto;
    errorCode!: ApiErrorCode;
    errorMessage!: string | undefined;
    errorTitle!: string | undefined;

    constructor(data?: IEmployee_NewDashboard_BasicDetailDtoApiResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.responseData = _data["responseData"] ? Employee_NewDashboard_BasicDetailDto.fromJS(_data["responseData"]) : <any>undefined;
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.errorTitle = _data["errorTitle"];
        }
    }

    static fromJS(data: any): Employee_NewDashboard_BasicDetailDtoApiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new Employee_NewDashboard_BasicDetailDtoApiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : <any>undefined;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["errorTitle"] = this.errorTitle;
        return data; 
    }
}

export interface IEmployee_NewDashboard_BasicDetailDtoApiResponse {
    isSuccess: boolean;
    responseData: Employee_NewDashboard_BasicDetailDto;
    errorCode: ApiErrorCode;
    errorMessage: string | undefined;
    errorTitle: string | undefined;
}

